import { useEffect, useMemo, useRef, useState } from "react";
import FGField from "./FGField";
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import eye and eye-slash icons
import { InputCounter } from "../common/InputCounter";

export default function FGToggleTextPassword(props: JSX.IntrinsicElements["input"] & {
  label: string | JSX.Element | JSX.Element[];
  desc?: string | JSX.Element | JSX.Element[];
  footer?: string|JSX.Element|JSX.Element[];
  /** just keep toggling this value will autofocus the element */
  triggerFocus?: boolean;
  showPassword?: boolean; // Prop to control initial password visibility
  showMaxLength?: boolean;
  inputRef?: (ref: any) => void;
}) {
  const ref = useRef<HTMLInputElement>();
  const [showPassword, setShowPassword] = useState(props.showPassword || false); // State to toggle password visibility

  useEffect(() => {
    if (typeof props.inputRef === "function") {
      props.inputRef(ref.current);
    }
  }, [ref]);

  useEffect(() => {
    if (typeof props.triggerFocus !== "undefined") {
      setTimeout(() => ref.current && ref.current.focus(), 50);
    }
  }, [props.triggerFocus]);

  // Function to toggle password visibility
  const togglePasswordVisibility = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPassword(!showPassword);

    try {
      const curr = ref.current;
      const len = curr.value.length;

      setTimeout(() => {
        curr.focus();
        curr.setSelectionRange(len, len);
      }, 100);
    } catch (ignore) {}
  };

  // since we need to pass everything to the target element, we make it safe
  // by removing unwanted attributes that React doesn't like.
  const safeInputProps = useMemo(() => {
    const newSafeProps = { ...props };
    delete newSafeProps["label"];
    delete newSafeProps["desc"];
    delete newSafeProps["triggerFocus"];
    delete newSafeProps["showPassword"];
    delete newSafeProps["showMaxLength"];
    delete newSafeProps["inputRef"];

    return newSafeProps;
  }, [props]);

  return (
    <FGField name={props.name} label={props.label} desc={props.desc} comp="FGToggleTextPassword">
      <div className="fg__field__password-toggle-container">
        <input
          ref={ref}
          type={showPassword ? "text" : "password"}
          id={props.name}
          style={{width : "100%"}}
          {...safeInputProps}
          />
        {/* Icon to toggle password visibility */}
        <button style={{
            background: "none",
            border: "none",
            position: 'absolute',
            top: '50%',
            right: '10px',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            userSelect: "none"
          }}
          type="button"
          onClick={togglePasswordVisibility as any}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>

      {props.showMaxLength && <InputCounter value={props?.value ?? 0}
        maxLength={props.maxLength}
      />}

      <>{props.footer && props.footer}</>
    </FGField>
  );
}
